const toTitleCaseFromCode = (value = "") =>
  String(value)
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export function normalizePermissionsCategories(rawResponse) {
  const payload = rawResponse?.data ?? rawResponse;
  const list = Array.isArray(payload) ? payload : (payload?.data ?? []);
  if (!Array.isArray(list)) return [];

  const grouped = new Map();

  list.forEach((item) => {
    const groupName = item?.group || "Other";
    if (!grouped.has(groupName)) {
      grouped.set(groupName, {
        id: groupName.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
        name: groupName,
        description: null,
        permissions: [],
      });
    }

    grouped.get(groupName).permissions.push({
      id: item?.id,
      code: item?.code,
      label: item?.code ? toTitleCaseFromCode(item.code) : "Unnamed Permission",
      description: item?.description ?? null,
    });
  });

  return Array.from(grouped.values());
}

export function normalizeRolePermissionIds(rawResponse) {
  const raw = rawResponse?.data ?? rawResponse;
  const source = Array.isArray(raw) ? raw : (raw?.permissions ?? raw?.data ?? raw?.items ?? []);

  if (!Array.isArray(source)) return [];

  return source
    .map((item) => {
      if (typeof item === "string") return item;
      if (item && typeof item === "object") {
        return item.permissionId || item.id || item.permission_id || item.code || null;
      }
      return null;
    })
    .filter(Boolean);
}

export function mapUpdateRolePermissionsResponse(responseData, fallbackPermissionIds) {
  const rows = responseData?.data?.data;
  const next = Array.isArray(rows)
    ? rows.map((row) => row?.id).filter(Boolean)
    : fallbackPermissionIds;
  return next;
}
